import React from 'react';
import { Link } from 'react-head';
export var MotionbookFullView = function (_a) {
    var _b = _a.deviation, motionBook = _b.motionBook, title = _b.title, width = _a.width, height = _a.height;
    if (!motionBook || !motionBook.embedUrl) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Link, { rel: "preload", href: motionBook.embedUrl, as: "document" }),
        React.createElement("iframe", { title: title, src: motionBook.embedUrl, style: { width: width, height: height } })));
};
export default MotionbookFullView;
//# sourceMappingURL=Motionbook.js.map